export default {
  name: 'Search',
  components: {
  },
  data () {
    return {
      columnSettings: [],
    }
  },
};